var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hideToolbar)?_c('v-toolbar',{staticClass:"secondary-toolbar",attrs:{"dense":!_vm.sparse,"flat":"","dark":"","bottom":""}},[_vm._t("toolbar-items")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }